import { combineReducers } from 'redux';
import { getJSON } from 'redux-api-middleware';
import apiGenerator from '../apiGenerator';
import Transaction, { txToApiMap } from '../../models/Transaction';
import { mapApiToModel } from '../../models/modelMapper';
import FinanceSummaryData from '../../models/FinanceSummaryData';

// Actions
const GET_TRANSACTIONS_REQUEST = 'ctm/txs/GET_TRANSACTIONS_REQUEST';
const GET_TRANSACTIONS_SUCCESS = 'ctm/txs/GET_TRANSACTIONS_SUCCESS';
const GET_TRANSACTIONS_FAILURE = 'ctm/txs/GET_TRANSACTIONS_FAILURE';
const GET_FINANCES_REQUEST = 'ctm/txs/GET_FINANCES_REQUEST';
const GET_FINANCES_SUCCESS = 'ctm/txs/GET_FINANCES_SUCCESS';
const GET_FINANCES_FAILURE = 'ctm/txs/GET_FINANCES_FAILURE';

// Action Creators
export function fetchTransactions() {
  return apiGenerator({
    endpoint: 'transactions',
    method: 'GET',
    types: [
      GET_TRANSACTIONS_REQUEST,
      {
        type: GET_TRANSACTIONS_SUCCESS,
        payload: (action, state, res) =>
          getJSON(res).then(data => data.map(d => mapApiToModel(d, txToApiMap, Transaction))),
      },
      GET_TRANSACTIONS_FAILURE,
    ],
  });
}

export function fetchFinances(level = 'full') {
  return apiGenerator({
    endpoint: `finances?${level}`,
    method: 'GET',
    types: [
      GET_FINANCES_REQUEST,
      {
        type: GET_FINANCES_SUCCESS,
        payload: (action, state, res) =>
          getJSON(res).then((data) => {
            const catLevel = data.categoryData.map(cd => new FinanceSummaryData(cd));
            const subcatLevel = data.subCategoryData.map(scd => new FinanceSummaryData(scd));
            return {
              catLevel,
              subcatLevel,
            };
          }),
      },
      GET_FINANCES_FAILURE,
    ],
  });
}

// Reducers
export function entries(state = [], action) {
  switch (action.type) {
    case GET_TRANSACTIONS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

const summaryDataInitialState = {
  catLevel: [],
  subcatLevel: [],
};
export function summaryData(state = summaryDataInitialState, action) {
  switch (action.type) {
    case GET_FINANCES_SUCCESS:
      return {
        catLevel: action.payload.catLevel,
        subcatLevel: action.payload.subcatLevel,
      };
    default:
      return state;
  }
}

export function isFetching(state = false, action) {
  switch (action.type) {
    case GET_TRANSACTIONS_REQUEST:
    case GET_FINANCES_REQUEST:
      return !action.error;
    case GET_TRANSACTIONS_SUCCESS:
    case GET_TRANSACTIONS_FAILURE:
    case GET_FINANCES_SUCCESS:
    case GET_FINANCES_FAILURE:
      return false;
    default:
      return state;
  }
}

export function fetched(state = false, action) {
  switch (action.type) {
    case GET_TRANSACTIONS_SUCCESS:
    case GET_FINANCES_SUCCESS:
      return new Date();
    default:
      return state;
  }
}

export default combineReducers({
  entries,
  summaryData,
  isFetching,
  fetched,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/transactions.js